





































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Passenger from '../models/Passenger';
import TransportationPermission, { TransportationPermissionSourceEnum } from '../models/TransportationPermission';
import TransportationPermissionInfo from '../models/TransportationPermissionInfo';

@Component({
    components: {}
})
export default class TransportationPermissionList extends Vue {
  permissionSource = TransportationPermissionSourceEnum;
  
  @Prop({ required: true }) private passenger!: Passenger;
  @Prop({ default: false }) private allowUserInput!: boolean;
  @Prop({ default: () => [] }) private passengerGroupIds!: number[];

  get loading(): boolean {
    return this.$store.state.passenger.pending.getPassengerTransportationPermissionInfo;
  }

  get passengerInfoIsBeingUpdated() {
    const hasMovitId = this.passenger.movitId ? true : false;
    const hasOrganizationId = this.passenger.organizationId ? true : false;
    const hasPermissions = this.transportationPermissions.length > 0;
    return !hasPermissions && !hasMovitId && !hasOrganizationId;
  }

  get transportationPermissions(): TransportationPermission[] {
    
    const transportationPermissionInfo: TransportationPermissionInfo = this.$store.state.passenger.transportationPermissionInfos
      .find((tpi: TransportationPermissionInfo) => tpi.timitPassengerId === this.passenger.id);
    
    if (transportationPermissionInfo) {
      const permissions = transportationPermissionInfo.permissions;
      return permissions.sort((a, b) => {
          if (new Date(a.startDate).getTime() < new Date(b.startDate).getTime()) {
              return -1;
          }
          if (new Date(a.startDate).getTime() > new Date(b.startDate).getTime()) {
              return 1;
          }
          return 0;
      });
    }
    return [];
  }
  
  get transportationPermissionHeaders(): any[]{
    return [
      { i18n: 'transportationPermission.startDate', text: 'Starts from', align: 'left', sortable: true, value: 'startDateFormatted' },
      { i18n: 'transportationPermission.endDate', text: 'Valid through', align: 'left', sortable: true, value: 'endDateFormatted' },
      { i18n: 'transportationPermission.type', text: 'Type', align: 'left', sortable: true, value: 'name' },
      { i18n: 'transportationPermission.quota', text: 'Transportation quota', align: 'left', sortable: true, value: 'initialQuota' },
      { i18n: 'transportationPermission.expressQuota', text: 'Express quota', align: 'left', sortable: true, value: 'initialExpressQuota' },
      { i18n: 'transportationPermission.quotaTime', text: 'Quota timeframe', align: 'left', sortable: true, value: 'quotaTime' },
      // { text: 'Jäljellä', align: 'left', sortable: true, value: 'remainingQuotaFormatted' },
      { i18n: 'transportationPermission.note', text: 'Reason', align: 'left', sortable: true, value: 'note' },
    ];
  }

  get organizationSavePtpAsDraftByDefault() {
    return this.$store.getters['organization/organizationSavePtpAsDraftByDefault'](this.passenger.organizationId);
  }

  get organizationPtpDeductiblePaymentBillableAsDefault() {
    // tslint:disable-next-line:max-line-length
    return this.$store.getters['organization/organizationPtpDeductiblePaymentBillableAsDefault'](this.passenger.organizationId);
  }

  getQuotaTime(val: number): string {
    switch (val) {
      case 0:
        return this.$i18n.translate('transportationPermission.quotaTimes.month', 'A Month');
        break;
      case 1:
        return this.$i18n.translate('transportationPermission.quotaTimes.day', 'A Day');
        break;
      case 2:
        return this.$i18n.translate('transportationPermission.quotaTimes.week', 'A Week');
        break;
      case 3:
        return this.$i18n.translate('transportationPermission.quotaTimes.year', 'A Year');
        break;
      case 4:
        return this.$i18n.translate('transportationPermission.quotaTimes.fourMonths', 'Four months');
        break;
      case 5:
        return this.$i18n.translate('transportationPermission.quotaTimes.threeMonths', 'Three months');
        break;
      default:
        return this.$i18n.translate('transportationPermission.quotaTimes.undefined', 'Not defined!');
    } 
  }

  addPermission(){
    // passenger movit id
    const passengerId = this.passenger.movitId;
    const startDate = moment().add(1, "months").startOf("month").format("YYYY-MM-DD");
    const endDate = moment().add(1, "months").endOf("month").format("YYYY-MM-DD");
    const name = "";
    const tripDestinations = -1;
    const isDraft = this.organizationSavePtpAsDraftByDefault;
    const deductiblePayment = this.organizationPtpDeductiblePaymentBillableAsDefault ? 1 : 0;
    const editedTransportationPermission = 
      new TransportationPermission({passengerId, startDate, endDate, name,
       tripDestinations, isDraft, deductiblePayment});
    this.$emit('input', editedTransportationPermission); 
  }

  editPermission(item){
    this.$emit('input', TransportationPermission.CopyFrom(item));
  }

  isEditingDisabled(item: TransportationPermission) {
    if (!this.allowUserInput || this.passenger.inactive) {
      return true;
    }
    // 02.01.2023 Temporary solution to prevent creating duplicates when movit returns timit ptps that don't match.
    if (item.id === null) {
      return true;
    }

    return item.source !== TransportationPermissionSourceEnum.Timit;
  }
}
